import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SET_SSR_STATUS
    SET_DETAILS
    SET_REG_NUMBER_LIST
    SET_RECENT_TRANSACTION
`,
    {
        prefix: "echallan/"
    }
);
